import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Template from "@/common/layout/Template";
import TopNav from "@/common/layout/TopNav";

import RegisterVendor from "./Vendor";

const Card = ({ onClick, title, children }) => {
  return (
    <div className="max-w-sm rounded overflow-hidden shadow-lg p-4 cursor-pointer" onClick={onClick}>
      <div className="text-lg mb-2">{title}</div>
      <p className="text-mid-gray-400 text-base">
        {children}
      </p>
    </div>
  );
};

const Content = () => {
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();

  return (
    <>
      <h1 className="text-carnation-500 text-2xl mb-4">Join Talk</h1>
      <h2 className="text-lg mb-8">Select the option that describes you</h2>
      <div className="flex flex-col space-y-4 mb-8">
        <Card 
        onClick={() => {window.location.href = "/register";}}
        title="Internal TA/HR"
        >I have a corporate email address and a role in TA/HR.</Card>
        <Card 
          onClick={() => setSearchParams({ ta: "false" })} 
          title="Vendor"
          >I represent a TA Vendor Product</Card>
      </div>
      <div>Already a member? <button className="text-carnation-500" onClick={() => navigate('/sign-in')}>Sign In</button></div>
    </>
  );
};

const Register = () => {
  const [searchParams] = useSearchParams();

  const ta = searchParams.get("ta");

  return (
    <>
      <TopNav />
      <Template header="Create Account">
        <div className="bg-white rounded-sm shadow-xl flex flex-col justify-center items-center p-8">
          {(ta === "false") ? <RegisterVendor /> : <Content />}
        </div>
      </Template>
    </>
  );
};

export default Register;
